import Axios from "axios";
import { ApiResponse, handleApiErrors } from "..";
import * as Models from "./models";

const baseUrlGroups = () => {
  return `${process.env.REACT_APP_MOBILBASE_API}/api/v1/alarms/groups`;
};

const baseUrlPlans = () => {
  return `${process.env.REACT_APP_MOBILBASE_API}/api/v1/alarms/dutyplans`;
};

//
// Groups API
//
export interface duty {
  id: number;
  personId: number;
  groupId: number;
  dutys: dutyPlans[];
}
export interface dutyPlans {
  id: number;
  start_time: string;
  end_time: string;
  days: string[];
}
export async function getDutys() {
  return Axios.get<duty[]>(`${baseUrlPlans()}`)
    .then((res) => {
        if(res)
      return res;
    })
    .catch((e) => handleApiErrors<Models.Duty[]>(e));
}

export async function getGroups(): Promise<ApiResponse<Models.Group[]>> {
  return Axios.get<Models.Group[]>(`${baseUrlGroups()}`)
    .then((res) => {
      return {
        data: res.data,
        errorStatus: undefined,
        errorMessage: undefined,
      };
    })
    .catch((e) => handleApiErrors<Models.Group[]>(e));
}

export async function storeGroup(
  group: Models.Group
): Promise<ApiResponse<Models.Group[]>> {
  let body: Models.GroupParams = {
    name: group.name,
    locations: group.locations,
    sendAlarm: group.sendAlarm,
    sendAlarmDeactivated: group.sendAlarmDeactivated,
    sendWarning: group.sendWarning,
    sendWarningDeactivated: group.sendWarningDeactivated,
    cpuCard: group.cpuCard,
    display: group.display,
    printer: group.printer,
    paperStatus: group.paperStatus,
    chipCardReader: group.chipCardReader,
    coinUnit: group.coinUnit,
    door: group.door,
    network: group.network,
  };
  let url: string = `${baseUrlGroups()}`;
  if (group.id > 0) {
    // Update an existing group
    url += `/${group.id}`;
  }

  return Axios.post<Models.Group[]>(url, { ...body })
    .then((res) => {
      return {
        data: res.data,
        errorStatus: undefined,
        errorMessage: undefined,
      };
    })
    .catch((e) => handleApiErrors<Models.Group[]>(e));
}

export async function deleteGroup(
  id: number
): Promise<ApiResponse<Models.Group[]>> {
  return Axios.delete<Models.Group[]>(`${baseUrlGroups()}/${id}`)
    .then((res) => {
      return {
        data: res.data,
        errorStatus: undefined,
        errorMessage: undefined,
      };
    })
    .catch((e) => handleApiErrors<Models.Group[]>(e));
}

//
// Duty plan API
//

export async function getDutyPlans(): Promise<ApiResponse<Models.Duty[]>> {
  return Axios.get<Models.Duty[]>(`${baseUrlPlans()}`)
    .then((res) => {
      return {
        data: res.data,
        errorStatus: undefined,
        errorMessage: undefined,
      };
    })
    .catch((e) => handleApiErrors<Models.Duty[]>(e));
}

export async function storeDuty(
  duty: Models.Duty
): Promise<ApiResponse<Models.Duty[]>> {
  let body: Models.DutyParams = {
    personId: duty.personId,
    groupId: duty.groupId,
    mon: duty.mon,
    tue: duty.tue,
    wed: duty.wed,
    thu: duty.thu,
    fri: duty.fri,
    sat: duty.sat,
    sun: duty.sun,
  };
  let url: string = `${baseUrlPlans()}`;
  if (duty.id > 0) {
    // Update an existing duty
    url += `/${duty.id}`;
  }

  return Axios.post<Models.Duty[]>(url, { ...body })
    .then((res) => {
      return {
        data: res.data,
        errorStatus: undefined,
        errorMessage: undefined,
      };
    })
    .catch((e) => handleApiErrors<Models.Duty[]>(e));
}

export async function deleteDuty(
  id: number
): Promise<ApiResponse<Models.Duty[]>> {
  return Axios.delete<Models.Duty[]>(`${baseUrlPlans()}/${id}`)
    .then((res) => {
      return {
        data: res.data,
        errorStatus: undefined,
        errorMessage: undefined,
      };
    })
    .catch((e) => handleApiErrors<Models.Duty[]>(e));
}
